import { render, staticRenderFns } from "./hand-thumbs-down.vue?vue&type=template&id=791d61d0&"
import script from "./hand-thumbs-down.vue?vue&type=script&lang=js&"
export * from "./hand-thumbs-down.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports